import request from '@/utils/request'
import { accountPrefix, wisdomsitePrefix } from './config'
// 班组管理
export function siteTeamTree(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteTeam/list',
    method: 'post',
    data
  })
}
export function siteProjectCompanyList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectCompany/listByProject',
    method: 'post',
    data
  })
}
export function addSiteTeam(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteTeam/add',
    method: 'post',
    data
  })
}
export function updateSiteTeam(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteTeam/update',
    method: 'post',
    data
  })
}
export function deleteSiteTeam(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteTeam/delete',
    method: 'post',
    data
  })
}
export function querySiteTeam(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteTeam/query',
    method: 'post',
    data
  })
}
export function teamQueryExtendByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteTeamAgreement/queryExtendByProject',
    method: 'post',
    data
  })
}
export function teamAddAndUpdateParamByProject(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteTeamAgreement/addAndUpdateParamByProject',
    method: 'post',
    data
  })
}
export function teamAgreementUpload(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreementUpload/teamAgreementUpload',
    method: 'post',
    data
  })
}

export function zqxyTeamInfo(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreement/zqxyTeamInfo',
    method: 'post',
    data
  })
}
export function pullTeam(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreementPull/pullTeam',
    method: 'post',
    data
  })
}

// 班组管理

// 区域管理
export function siteAreaList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteArea/list',
    method: 'post',
    data
  })
}
export function addSiteArea(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteArea/add',
    method: 'post',
    data
  })
}
export function updateSiteArea(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteArea/update',
    method: 'post',
    data
  })
}
export function deleteSiteArea(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteArea/delete',
    method: 'post',
    data
  })
}
export function querySiteArea(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteArea/query',
    method: 'post',
    data
  })
}
export function siteProjectDataTree(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProject/dataTree',
    method: 'post',
    data
  })
}
export function dataTreePersonType(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProject/dataTreePersonType',
    method: 'post',
    data
  })
}
export function querySiteAreaObject(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAreaObject/query',
    method: 'post',
    data
  })
}
export function siteAreaObjectAddAndUpdate(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAreaObject/addAndUpdate',
    method: 'post',
    data
  })
}
export function querySiteVerifyDeviceByArea(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteVerifyDevice/queryByArea',
    method: 'post',
    data
  })
}

// 项目信息

export function updateSiteProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProject/updateByProject',
    method: 'post',
    data
  })
}
export function siteProjectAgreementListByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectAgreement/listByProject',
    method: 'post',
    data
  })
}
export function queryExtendByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteDeviceAgreement/queryExtendByProject',
    method: 'post',
    data
  })
}
export function deviceAddAndUpdateParamByProject(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteDeviceAgreement/addAndUpdateParamByProject',
    method: 'post',
    data
  })
}
export function projectQueryExtendByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectAgreement/queryExtendByProject',
    method: 'post',
    data
  })
}
export function addAndUpdateParamByProject(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteProjectAgreement/addAndUpdateParamByProject',
    method: 'post',
    data
  })
}
export function saveSiteProjectPrivateConfig(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectPrivateConfig/save',
    method: 'post',
    data
  })
}
export function projectUpload(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreementUpload/projectUpload',
    method: 'post',
    data
  })
}
export function querySiteBusinessQrcodeInfo(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteBusinessQrcodeInfo/query',
    method: 'post',
    data
  })
}
export function genBusinessInfoQrCodeData(data) {
  return request({
    url:
      accountPrefix +
      '/front/tenementBusinessQrCodeGen/genBusinessInfoQrCodeData',
    method: 'post',
    data
  })
}

// 参建单位

export function companyListByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectCompany/listByProject',
    method: 'post',
    data
  })
}
export function companyQueryExtendByProject(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteProjectCompanyAgreement/queryExtendByProject',
    method: 'post',
    data
  })
}
export function updateExtendParam(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteProjectCompanyAgreement/updateExtendParam',
    method: 'post',
    data
  })
}
export function agreementCompanyListByProject(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteProjectCompanyAgreement/companyListByProject',
    method: 'post',
    data
  })
}
export function companyAgreementUpload(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreementUpload/companyAgreementUpload',
    method: 'post',
    data
  })
}
export function zqxyCompanyInfo(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreement/zqxyCompanyInfo',
    method: 'post',
    data
  })
}
export function pullCompany(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreementPull/pullCompany',
    method: 'post',
    data
  })
}
export const queryMaterial = (data) =>
  request({
    url: wisdomsitePrefix + '/front/siteCompanyEntryMaterials/queryMaterial',
    method: 'post',
    data
  })
export const saveOrUpdateMaterial = (data) =>
  request({
    url: wisdomsitePrefix + '/front/siteCompanyEntryMaterials/saveOrUpdate',
    method: 'post',
    data
  })
export const addSiteCompany = (data) =>
  request({
    url: wisdomsitePrefix + '/front/siteCompany/add',
    method: 'post',
    data
  })
export const companyUnBindAgreementList = (data) =>
  request({
    url:
      wisdomsitePrefix +
      '/front/siteProjectCompanyAgreement/companyUnBindAgreementList',
    method: 'post',
    data
  })
export const siteProjectCompanyAgreementQueryExtend = (data) =>
  request({
    url: wisdomsitePrefix + '/front/siteProjectCompanyAgreement/queryExtend',
    method: 'post',
    data
  })
export const siteProjectCompanyAgreementUpdateExtendParam = (data) =>
  request({
    url:
      wisdomsitePrefix + '/front/siteProjectCompanyAgreement/updateExtendParam',
    method: 'post',
    data
  })
export const siteProjectCompanyAgreementRelation = (data) =>
  request({
    url:
      wisdomsitePrefix +
      '/front/siteProjectCompanyAgreement/addAndUpdateRelation',
    method: 'post',
    data
  })
// 车队管理

export function fleetManageTree(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteFleetManage/fleetManageTree',
    method: 'post',
    data
  })
}
export function addsiteFleet(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteFleetManage/add',
    method: 'post',
    data
  })
}
export function siteFleetDetail(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteFleetManage/detail',
    method: 'post',
    data
  })
}
export function updateSiteFleet(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteFleetManage/update',
    method: 'post',
    data
  })
}
export function deleteSiteFleet(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteFleetManage/delete',
    method: 'post',
    data
  })
}

// 政企协议

export function zqxyCompanyPageList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreement/zqxyCompanyPageList',
    method: 'post',
    data
  })
}
export function zqxyTeamPageList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreement/zqxyTeamPageList',
    method: 'post',
    data
  })
}
export function zqxyPersonPageList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreement/zqxyPersonPageList',
    method: 'post',
    data
  })
}

// 微信管理员
export function queryBindManagerPage(data) {
  return request({
    url: accountPrefix + '/front/wx/manager/queryBindManagerPage',
    method: 'post',
    data
  })
}
export function unBindManager(data) {
  return request({
    url: accountPrefix + '/front/wx/manager/unBindManager',
    method: 'post',
    data
  })
}
export function getBusinessInfoQrCodeData(data) {
  return request({
    url:
      accountPrefix +
      '/front/tenementBusinessQrCodeGen/genBusinessInfoQrCodeData',
    method: 'post',
    data
  })
}
export function genUserProjectInfoQrCodeData(data) {
  return request({
    url:
      accountPrefix +
      '/front/tenementBusinessQrCodeGen/genUserProjectInfoQrCodeData',
    method: 'post',
    data
  })
}
export function addSiteCustomScreen(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCustomScreen/add',
    method: 'post',
    data
  })
}
export function siteCustomScreenList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCustomScreen/list',
    method: 'post',
    data
  })
}
export function deleteSiteCustomScreen(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCustomScreen/delete',
    method: 'post',
    data
  })
}
export function querySiteCustomScreen(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCustomScreen/query',
    method: 'post',
    data
  })
}
export function updateSiteCustomScreen(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCustomScreen/update',
    method: 'post',
    data
  })
}
export function uploadByStr(data) {
  return request({
    url: accountPrefix + '/front/file/uploadByStr',
    method: 'post',
    data
  })
}
export function uploadIdCardBase64(data) {
  return request({
    url: accountPrefix + '/front/file/uploadIdCardBase64',
    method: 'post',
    data
  })
}

// 自定义大屏
export function personInCountChartData(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectScreen/personInCountChartData',
    method: 'post',
    data
  })
}
export function outInChartData(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectScreen/outInChartData',
    method: 'post',
    data
  })
}
export function teamData(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectScreen/teamData',
    method: 'post',
    data
  })
}
export function workerTypeData(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectScreen/workerTypeData',
    method: 'post',
    data
  })
}
export function verifyRecordAgreementBatchUpload(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteAgreementUpload/verifyRecordAgreementBatchUpload',
    method: 'post',
    data
  })
}
export function companyAgreementExit(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreementExit/companyAgreementExit',
    method: 'post',
    data
  })
}
export function teamAgreementExit(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreementExit/teamAgreementExit',
    method: 'post',
    data
  })
}
export function caDeviceQueryExtendByProject(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteProjectCaDeviceAgreement/queryExtendByProject',
    method: 'post',
    data
  })
}
export function caDeviceAddAndUpdateParamByProject(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteProjectCaDeviceAgreement/addAndUpdateParamByProject',
    method: 'post',
    data
  })
}
export function updateTrainRule(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProject/updateTrainRule',
    method: 'post',
    data
  })
}
export function updateSiteProjectRuleConfig(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectRuleConfig/addOrUpdate',
    method: 'post',
    data
  })
}
export function specialWorkerTypeList(data) {
  return request({
    url: wisdomsitePrefix + '/front/specialWorkerType/list',
    method: 'post',
    data
  })
}
export function specialWorkerTypeSave(data) {
  return request({
    url: wisdomsitePrefix + '/front/specialWorkerType/saveOrUpdate',
    method: 'post',
    data
  })
}
export function resetSpecialWorkerType(data) {
  return request({
    url: wisdomsitePrefix + '/front/specialWorkerType/reset',
    method: 'post',
    data
  })
}
export function siteLedProgramList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLedProgram/pageList',
    method: 'post',
    data
  })
}
export function addSiteLedProgram(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLedProgram/add',
    method: 'post',
    data
  })
}
export function updateSiteLedProgram(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLedProgram/update',
    method: 'post',
    data
  })
}
export function querySiteLedProgram(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLedProgram/query',
    method: 'post',
    data
  })
}
export function deleteSiteLedProgram(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLedProgram/delete',
    method: 'post',
    data
  })
}
export function sendProgram(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLedProgram/sendProgram',
    method: 'post',
    data
  })
}
export function teamPersonCount(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteTeam/teamPersonCount',
    method: 'post',
    data
  })
}
export function workTypePersonCount(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteWorkerType/workTypePersonCount',
    method: 'post',
    data
  })
}
export function areaAttendance(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCustomScreen/areaAttendance',
    method: 'post',
    data
  })
}
export function tenementKeyManagerList(data) {
  return request({
    url: wisdomsitePrefix + '/front/tenementKeyManager/list',
    method: 'post',
    data
  })
}
export function queryAlarmErrorData(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteCraneDevice/queryAlarmErrorData',
    method: 'post',
    data
  })
}
export function updateAgreementExceptionNotice(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProject/updateAgreementExceptionNotice',
    method: 'post',
    data
  })
}
export function siteElevatorDeviceData(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteElevatorDevice/queryAlarmErrorData',
    method: 'post',
    data
  })
}
export function queryTrainData(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprRecord/queryTrainData',
    method: 'post',
    data
  })
}
export function queryMotorcadeData(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLprRecord/queryMotorcadeData',
    method: 'post',
    data
  })
}
export function queryElectricityDayData(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAepDevice/queryElectricityDayData',
    method: 'post',
    data
  })
}
export function queryElectricityMonthData(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAepDevice/queryElectricityMonthData',
    method: 'post',
    data
  })
}

export function copySiteLedProgram(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteLedProgram/copy',
    method: 'post',
    data
  })
}
export function saveSiteProjectRuleConfig(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectRuleConfig/addOrUpdate',
    method: 'post',
    data
  })
}
export function zqxyPersonContractPageList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreement/zqxyPersonContractPageList',
    method: 'post',
    data
  })
}
export function zqxyPersonCertPageList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreement/zqxyPersonCertPageList',
    method: 'post',
    data
  })
}
export function siteProjectTrainRelationList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectRuleConfig/relationList',
    method: 'post',
    data
  })
}
export function saveTrainRelation(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectRuleConfig/addOrUpdateTrain',
    method: 'post',
    data
  })
}
export function siteProjectCompanyUnPagelist(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectCompany/unPagelist',
    method: 'post',
    data
  })
}
export function addSiteProjectCompany(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectCompany/add',
    method: 'post',
    data
  })
}
